const steps = [
  {
    number: '01',
    icon: 'ri-radar-line',
    title: 'Capture Every Lead',
    description:
      'AI answers every call, qualifies web leads instantly, and routes them into your pipeline—24 hours a day, 7 days a week. Zero leads fall through the cracks.',
    stat: '94%',
    statLabel: 'fewer missed calls',
  },
  {
    number: '02',
    icon: 'ri-calendar-schedule-line',
    title: 'Automatically Schedule',
    description:
      'Real-time booking synced to your calendar. Jobs are confirmed, reminders sent, and dispatch coordinated—without anyone lifting a finger.',
    stat: '3.2x',
    statLabel: 'more bookings',
  },
  {
    number: '03',
    icon: 'ri-loop-right-line',
    title: 'Follow Up Until Closed',
    description:
      'Missed call text-backs, estimate follow-up sequences, and re-engagement campaigns run automatically until every lead converts or opts out.',
    stat: '67%',
    statLabel: 'higher close rate',
  },
];

export default function SolutionSection() {
  return (
    <section id="how-it-works" className="bg-[#F5F5F7] py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto mb-20">
          <p className="text-[#6E6E73] text-sm font-semibold uppercase tracking-widest mb-5">
            The Solution
          </p>
          <h2 className="text-5xl lg:text-6xl font-extrabold text-[#0A0A0A] leading-none tracking-tighter mb-6">
            Capture. Book. Close.
          </h2>
          <p className="text-[#6E6E73] text-xl font-light leading-relaxed">
            Replace manual chaos with automated workflows that run around the
            clock—every lead captured, qualified, and moved through your pipeline.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-5">
          {steps.map((step) => (
            <div
              key={step.number}
              className="bg-white rounded-3xl p-10 hover:-translate-y-1 transition-all duration-300 group"
            >
              <div className="flex items-start justify-between mb-8">
                <span className="text-[#E5E5EA] text-5xl font-extrabold leading-none tracking-tighter">
                  {step.number}
                </span>
                <div className="w-10 h-10 flex items-center justify-center bg-[#F5F5F7] rounded-xl group-hover:bg-[#0A0A0A] transition-colors">
                  <i className={`${step.icon} text-[#0A0A0A] group-hover:text-white text-lg transition-colors`} />
                </div>
              </div>
              <h3 className="text-[#0A0A0A] text-2xl font-bold mb-4 tracking-tight leading-snug">
                {step.title}
              </h3>
              <p className="text-[#6E6E73] text-sm leading-relaxed mb-8">
                {step.description}
              </p>
              <div className="pt-6 border-t border-[#F5F5F7]">
                <span className="text-3xl font-extrabold text-[#0A0A0A] tracking-tighter">{step.stat}</span>
                <span className="text-[#6E6E73] text-sm ml-2">{step.statLabel}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
